<template>
  <modal
    name="editorIconModal"
    adaptive
    :width="1000"
    :height="600"
    classes="wf-shadow-xl wf-rounded-lg wf-bg-gray-100"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="">
      <div
        class="wf-flex wf-flex-col wf-justify-between wf-w-full wf-bg-white icon-container"
      >
        <!-- Title Modal -->
        <div class="dialog-title wf-flex-1 wf-px-4 wf-pt-2">
          <h4
            class="wf-text-blue-700 wf-font-bold wf-lowercase"
          ><i class="fas fa-list"></i> Icon Library</h4>
          <div class="wf-border-blue-700 wf-w-12 wf-border-2"></div>
        </div>
        <!-- END Title Modal -->

        <!-- Content Modal -->
        <div class="dialog-content wf-flex-none wf-px-4">
          <div class="wf-flex">
            <!-- SideBAR  -->
            <div class="sidebar-icon wf-flex-1 wf-w-1/4 wf--ml-4">
              <div class="wf-mt-8">
                <div
                  v-for="(item, key) in menuItems" :key="key"
                  class="wf-flex wf-items-center wf-space-x-4 wf-py-3 wf-px-4 wf-text-gray-600 wf-font-normal wf-text-sm wf-cursor-pointer"
                  @click="fetchFAStyles(item.type)"
                  :class="{'wf-bg-gray-300 wf-text-blue-500 wf-border-l-4 wf-border-blue-500 wf-pl-3': activeMenu === item.type}"
                >
                  <i :class="item.classIcon"></i>
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
            <!-- Content ICONS  -->
            <div class="content-icon wf-w-3/4">
              <!-- Seacrh Bar -->
              <div class="wf-w-full wf-px-4">
                <div class="wf-relative wf-max-w-full wf-mt-3">
                  <span class="wf-absolute wf-inset-y-0 wf-left-0 wf-pl-3 wf-flex wf-items-center">
                    <svg viewBox="0 -2 22 24" fill="none" class="wf-w-6 wf-h-6 wf-fill-current wf-text-gray-600 wf-font-medium"><path stroke="currentColor" stroke-width="0" stroke-linecap="square" d="M12.9 14.32a8 8 0 111.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 108 2a6 6 0 000 12z"></path></svg>
                  </span>
                  <input
                    name="searchIcon"
                    placeholder="Filter by name..."
                    type="text"
                    v-model="searchIcon"
                    class="wf-block wf-w-full wf-rounded-lg wf-bg-gray-200 wf-border wf-border-gray-400 wf-pl-10 wf-pr-2 wf-py-2 wf-text-gray-700 wf-text-sm wf-leading-tight wf-placeholder-gray-500 focus:wf-outline-none focus:wf-bg-white"
                  />
                </div>
              </div>
              <!-- Icon List Content -->
              <div class="wf-w-full wf-overflow-y-auto wf-px-4 wf-rounded-b-lg" style="height: 470px;">
                <div class="wf-flex wf-flex-wrap wf-justify-around wf-mt-2">
                  <div
                    v-for="(icon, index) in filteredIcons"
                    :key="index"
                    class="wf-flex wf-flex-wrap wf-justify-center wf-rounded wf-w-1/6 wf-mr-3 wf-mt-3 wf-bg-white wf-border-2 wf-border-white wf-shadow hover:wf-shadow-md wf-px-2 wf-py-4 wf-cursor-pointer"
                    :class="{'selected-icon': selectedIcon === icon}"
                    @click="handleIconSource(icon)"
                  >
                    <i
                      class="fa-lg wf-block wf-text-center wf-w-full wf-text-gray-600"
                      :class="icon"
                    ></i>
                    <span
                      class="wf-font-light wf-truncate wf-text-gray-500 wf-text-xxs wf-mt-1 wf-capitalize"
                    >{{ normalizeTitle(icon) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END Content Modal -->

        <!-- Footer Model -->
        <div class="dialog-footer wf-flex-1 wf-bg-white wf-flex wf-flex-row-reverse wf-px-5 wf-py-2 shadow-t wf-z-50">
          <button
            class="wf-text-uppercase wf-bg-green-500 wf-rounded-sm wf-px-4 wf-py-1 wf-text-white hover:wf-bg-green-600 wf-uppercase"
            @click="addIconSource"
          >Insert</button>
        </div>
        <!-- END Footer Modal -->
      </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import ArrayManipulation from '../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    data() {
      return {
        activeMenu: 'solid',
        menuItems: [
          {
            title: 'Font Awesome - Solid',
            type: 'solid',
            classIcon: 'fas fa-flag'
          }, {
            title: 'Font Awesome - Regular',
            type: 'regular',
            classIcon: 'far fa-flag'
          }, {
            title: 'Font Awesome - Brands',
            type: 'brands',
            classIcon: 'fab fa-font-awesome-flag'
          }
        ],
        icons: [],
        searchIcon: '',
        //beforeOpen Function
        pageComponentIndex: null,
        columnIndex: null,
        module: null,
        rowIndex: null,
        sectionIndex: null,
        componentIndex: null,
        selectedIcon: null,
      }
    },
    methods: {
      beforeOpen(event) {
        this.fetchFAStyles();
        this.columnIndex = event.params.column
        this.componentIndex = event.params.component
        this.module = event.params.module
        this.rowIndex = event.params.row
        this.sectionIndex = event.params.section
        this.pageComponentIndex = event.params.pageComponent
        this.selectedIcon = event.params.elementContent
      },
      closed() {
        this.columnIndex = null
        this.componentIndex = null
        this.device = null
        this.rowIndex = null
        this.sectionIndex = null
      },
      normalizeTitle(title) {
        return title.replace(new RegExp('^(fas|far|fab)\\s(fa-)', 'gi'), '')
      },
      async fetchFAStyles(type = 'solid') {
        this.activeMenu = type;
        const { data } = await axios.get(`/icons/${type}.json`);
        this.icons = data;
      },
      handleIconSource(source) {
        this.selectedIcon = source
      },
      addIconSource() {
        const iconSource = this.selectedIcon.split(' ')
        this.addToObject(this.module, {
          class: iconSource[0],
          icon: iconSource[1]
        }, 'content')
        this.$modal.hide('editorIconModal')
      }
    },
    computed: {
      element() {
        let element = {
          pageComponent: this.pageComponentIndex,
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex,
          component: this.componentIndex,
          componentSection: this.componentSectionIndex,
          componentRow: this.componentRowIndex,
          componentColumn: this.componentColumnIndex,
          componentComponent: this.componentComponentIndex,
        }

        let newElement = Object.keys(element)
          .filter(key => element[key] != null)
          .reduce((obj, key) => {
            obj[key] = element[key]
            return obj
          }, new Object)

        return newElement
      },
      filteredIcons() {
        const vm = this;
        const icons = this.icons;
        if (vm.searchIcon === '') return icons;
        return icons.filter( item => item.toLowerCase().includes(vm.searchIcon));
      }
    }
  }
</script>

<style lang="css">
  .content-icon .selected-icon {
      @apply wf-border-2 wf-border-blue-500 wf-bg-gray-100;
  }
</style>
